export default __webpack_public_path__ + "static/media/render.e0dd03be.png";